<template>
  <div class="modal_card reverse" style="width: 100vw">
    <div class="modal_form">
      <i @click="$emit('close-modal')" class="icon-close"></i>
      <h1>Добавить курс данному студенту</h1>
      <form @submit.prevent="$emit('assign')">
        <b-field label="Дата начала" class="input_datepicker label_left grey is-right">
          <b-datepicker
            animation=""
            v-model="modalInfo.date_start"
            size="is-small"
            placeholder="__.__.____"
          ></b-datepicker>
        </b-field>
        <CoursesList 
          :checked-courses="CheckedCourses" 
          :course-add="true" 
          :categories-list="CategoriesList"
          :user-courses='UserCourses' 
        />

        <button class="add_course_button modal_button left_button" type="submit">Добавить</button>
        <button type="button" @click="$emit('close-modal')" class="close_button modal_button right_button">
          Отмена
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import CoursesList from '@/components/right_block/CoursesList'

export default {
  components: {
    CoursesList
  },
  props: {
    modalInfo: {
      default: () => {},
      type: Object
    },
    CategoriesList: {
      default: () => [],
      type: Array
    },
    CheckedCourses: {
      default: () => {},
      type: Object
    },
    UserCourses: {
      default: () => [],
      type: Array
    }
  }
}
</script>
